import { User } from "../../../user/types";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "../DbtDocsCollaborationProvider";
import {
  DbtDocsState,
  refetchConversations,
  resolveConversationGroup,
  updateSelectedConversationId,
} from "../DbtDocsReducer";
import ConversationGroupProvider from "./context/ConversationsProvider";
import { ConversationGroup } from "./context/types";

const ConversationGroups = () => {
  const source = useDbtDocsCollaborationSelector(state => state.source) as DbtDocsState["source"];
  const conversationGroups = useDbtDocsCollaborationSelector(
    state => state.conversations
  ) as DbtDocsState["conversations"];
  const selectedConversationId = useDbtDocsCollaborationSelector(
    state => state.selectedConversationId
  ) as DbtDocsState["selectedConversationId"];
  const shareId = useDbtDocsCollaborationSelector(
    state => state.shareId
  ) as DbtDocsState["shareId"];

  const users = useDbtDocsCollaborationSelector(state => state.users) as Record<number, User>;
  const currentUserId = useDbtDocsCollaborationSelector(state => state.currentUserId) as User["id"];

  const dispatch = useDbtDocsCollaborationDispatch();

  if (!currentUserId || !shareId) {
    return null;
  }

  const user = users[currentUserId];

  const onResolve = (conversationGroupId: ConversationGroup["conversation_group_id"]) => {
    dispatch(resolveConversationGroup({ shareId, conversationGroupId }));
  };
  const onSelect = (conversationGroupId: ConversationGroup["conversation_group_id"]) => {
    dispatch(updateSelectedConversationId(conversationGroupId));
  };

  const onReplyAdd = (conversationGroupId: ConversationGroup["conversation_group_id"]) => {
    console.log("onReplyAdd", conversationGroupId);
    dispatch(refetchConversations());
  };

  if (!conversationGroups || !Object.keys(conversationGroups).length) {
    return <div>No conversations yet!</div>;
  }

  return (
    <div>
      {Object.values(conversationGroups).map(conversationGroup => (
        <ConversationGroupProvider
          key={conversationGroup.conversation_group_id}
          conversationGroup={conversationGroup}
          shareId={shareId as unknown as number}
          isSelected={selectedConversationId === conversationGroup.conversation_group_id}
          currentUser={user}
          onResolve={() => onResolve(conversationGroup.conversation_group_id)}
          onSelect={() => onSelect(conversationGroup.conversation_group_id)}
          users={users}
          onReplyAdd={() => onReplyAdd(conversationGroup.conversation_group_id)}
          source={source}
        />
      ))}
    </div>
  );
};

export default ConversationGroups;
